if (!customElements.get('mbito-shipping-progress')) {
  customElements.define('mbito-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      const base = this.dataset.baseCurrency;
      const currency = this.dataset.currency;
      const exchange = window.Shopify?.currency;
      const rate = currency === base ? 1 : exchange?.active === currency ? Number(exchange.rate) : NaN;
      const baseThreshold = Number(this.dataset.baseThreshold);
      if (this.dataset.eligible !== 'true' || !Number.isFinite(rate) || rate <= 0 || baseThreshold <= 0) return;

      // Round up so a fraction of a cent cannot unlock shipping before the native threshold.
      const threshold = Math.ceil(baseThreshold * rate - 1e-6);
      const total = Math.max(0, Number(this.dataset.total));
      if (!Number.isFinite(total) || !Number.isSafeInteger(threshold) || threshold <= 0) return;
      const remaining = Math.max(0, threshold - total);
      const percentage = Math.min(100, total / threshold * 100);
      let money;
      try {
        money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
      } catch { return; }
      const label = remaining === 0 ? this.dataset.success : this.dataset.progress.replace('[price]', money.format(remaining / 100));
      const target = this.dataset.thresholdLabel.replace('[price]', money.format(threshold / 100));
      this.querySelector('[data-message]').textContent = label;
      this.querySelector('[data-threshold-label]').textContent = target;
      this.querySelector('[data-threshold-label]').hidden = false;
      const bar = this.querySelector('[role="progressbar"]');
      bar.style.setProperty('--value', `${percentage}%`);
      bar.setAttribute('aria-valuenow', String(percentage));
      bar.setAttribute('aria-valuetext', `${label} ${target}`);
      bar.classList.toggle('style--success', remaining === 0);
      bar.parentElement.hidden = false;
      this.dataset.threshold = String(threshold);
      this.dataset.remaining = String(remaining);
    }
  });
}
